var React = require('react');

function ContactSeparatorTopInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#EBF4F6","d":"M 0 0 L 971 110 L 971 0 L 0 0 Z","strokeWidth":"0","key":0}),React.createElement("path",{"fill":"#EBF4F6","d":"M 970 110 L 1920 0 L 1920 0 L 970 0 Z","strokeWidth":"0","key":1})]);
}

ContactSeparatorTopInline.defaultProps = {"viewBox":"0 0 1920 200"};

module.exports = ContactSeparatorTopInline;

ContactSeparatorTopInline.default = ContactSeparatorTopInline;
